import OpdekDeur from "entities/configurator/product-scene/doors/opdek";
import { ConfigurationProps } from "../../Door";

interface SingleOpdekProps extends ConfigurationProps {}

const SingleOpdek = ({
  materials,
  position,
  scale,
  doorSettings,
}: SingleOpdekProps) => {
  return (
    <group scale={scale}>
      <OpdekDeur
        materials={materials}
        position={position}
        showKozijn={false}
        kozijnSettings={doorSettings?.main?.kozijnSettings}
      />
    </group>
  );
};
export default SingleOpdek;
